export const Permissions = {
  RECADASTRAMENTO: {
    MENU: ["ROLE_CENSO_GERENCIA", "ROLE_CENSO_ATENDENTE","ROLE_CENSO_CONSULTA"],
    TODOS_PAIS: ["ROLE_CENSO_GERENCIA", "ROLE_CENSO_ATENDENTE_GOIASPREV","ROLE_CENSO_CONSULTA"],
    TELA: ["ROLE_CENSO_GERENCIA", "ROLE_CENSO_ATENDENTE","ROLE_CENSO_CONSULTA"],
  },
  RELATORIOS: {
    MENU: ["ROLE_CENSO_GERENCIA"],
    TELA: ["ROLE_CENSO_GERENCIA"],
  },
  USUARIO: {
    MENU: ["ROLE_CENSO_GERENCIA", "ROLE_CENSO_CALENDARIO"],
    TELA: ["ROLE_CENSO_GERENCIA", "ROLE_CENSO_CALENDARIO"],
  },
  AGENDAMENTO: {
    MENU: ["ROLE_CENSO_GERENCIA", "ROLE_CENSO_AGENDAR_BLOQUEIO"],
    TELA: ["ROLE_CENSO_GERENCIA", "ROLE_CENSO_AGENDAR_BLOQUEIO"],
  },
  AUDITORIA: {
    MENU: ["ROLE_CENSO_GERENCIA", "ROLE_CENSO_CALENDARIO"],
    TELA: ["ROLE_CENSO_GERENCIA", "ROLE_CENSO_CALENDARIO"],
  },
  CALENDARIOSCENSO: {
    MENU: ["ROLE_CENSO_GERENCIA", "ROLE_CENSO_CALENDARIO"],
    TELA: ["ROLE_CENSO_GERENCIA", "ROLE_CENSO_CALENDARIO"],
  },
  VALIDARCERTIDAO: {
    MENU: ["ROLE_CENSO_GERENCIA", "ROLE_CENSO_VALIDAR_CERTIDAO"],
    TELA: ["ROLE_CENSO_GERENCIA", "ROLE_CENSO_VALIDAR_CERTIDAO"],
  },
};

export const RoleHierarchy = {
  ROLE_CENSO_GERENCIA: [
    "ROLE_CENSO_GERENCIA",
    "ROLE_CENSO_ATENDENTE",
    "ROLE_CENSO_CONSULTA",
  ],

  ROLE_CENSO_ATENDENTE: [
    "ROLE_CENSO_ATENDENTE",
    "ROLE_CENSO_CONSULTA",
  ],

  ROLE_CENSO_ATENDENTE_GOIASPREV: [
    "ROLE_CENSO_ATENDENTE_GOIASPREV",
    "ROLE_CENSO_CONSULTA",
  ],

  ROLE_CENSO_CONSULTA: [
    "ROLE_CENSO_CONSULTA",
  ],

  ROLE_CENSO_CALENDARIO: [
    "ROLE_CENSO_CALENDARIO",
  ],

  ROLE_CENSO_AGENDAR_BLOQUEIO: [
    "ROLE_CENSO_AGENDAR_BLOQUEIO",
  ],

  ROLE_CENSO_VALIDAR_CERTIDAO: [
    "ROLE_CENSO_VALIDAR_CERTIDAO",
  ],
};

